module.exports = __webpack_public_path__ + "static/media/link-icon.6b8a7af0.svg";